var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('measure-detail',{attrs:{"id":_vm.measureId},on:{"loaded":_vm.setTitle}})}
var staticRenderFns = []

export { render, staticRenderFns }